import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Checkbox, FormControlLabel, FormGroup, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import './style.css'
import httpClient from '../../_util/api';
import CustomizedSnackbars from '../Snackbar/SnackBar';
import { hideLoader, showLoader } from '../../Store/mainSlice';
import { useRef } from 'react';

export default function ApprovePopup(props) {
    const id = props.id
    const CNICNo = props.CNICNo
    const stdId = props.stdId
    const role = localStorage.getItem('role')
    const open = useSelector((state) => state.approvePopupOpen)
    const snackbar_Ref = useRef()
    const dispatch = useDispatch()
    const [scroll, setScroll] = React.useState('paper');
    const [studentData, setStudentData] = React.useState({
        firstName: "",
        lastName: "",
        email: "",
        gender: "",
        address: "",
        town: "",
        phoneNo_Mobile: "",
        phoneNo_Home: "",
        CNICNo: "",
        // CNIC_type: "",
        // CNIC_dateOfIssue: "",
        // CNIC_placeOfIssue: "",
        presentHouseholdIncome: 0,
        totalFamilyMembers: 0,
        fatherName: "",
        motherName: "",
        orphan: "",
        signature: "",
        password: "",
        confirmPassword: "",
        courseTitle: "",
        grade: "",
        institutionName: "",
        institutionAddress: "",
        tuttionFee: 0,
        lastInstitutionAttended: "",
        classOfLastInstitution: "",
        requestedAmount: 0,
        description: "",
        referenceName1: "",
        referenceEmail1: "",
        referencePhone1: "",
        referenceName2: "",
        referenceEmail2: "",
        referencePhone2: "",
        resultOfLastExamPic: "",
        feeVoucherPic: "",
        CNICPic: "",
        parentCNICPic: "",
        proofOfIncomePic: "",
        currentElectricBill: "",
    })

    const handleClickOpen = (scrollType) => () => {
        setScroll(scrollType);
    };

    const handleClose = () => {
        props.onClose()
    };

    const approvehandler = async () => {
        dispatch(showLoader())
        const res = await httpClient.post(`/students/approveStudent/${id}/${CNICNo}`).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", res.data.message, "", "i-chk-circle");
        })

        if (res.status === 200) {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("success", res.data.message, "", "i-chk-circle");
            setTimeout(() => {
                handleClose()
            }, 3000);

        }
    }

    const approveByAlKauserHandler = async () => {
        dispatch(showLoader())
        const res = await httpClient.post(`/students/approveStudentByAlKauser/${id}/${CNICNo}`).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", res.data.message, "", "i-chk-circle");
        })

        if (res.status === 200) {
            console.log("res", res);
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("success", res.data.message, "", "i-chk-circle");
            setTimeout(() => {
                handleClose()
            }, 3000);
        }
    }

    const rejectHandler = async () => {
        dispatch(showLoader())
        const res = await httpClient.post(`/students/rejectStudent/${id}/${CNICNo}`).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", res.data.message, "", "i-chk-circle");
        })

        if (res.status === 200) {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("success", res.data.message, "", "i-chk-circle");
            setTimeout(() => {
                handleClose()
            }, 3000);
        }
    }

    const rejectByAlKauserHandler = async () => {
        dispatch(showLoader())
        const res = await httpClient.post(`/students/rejectStudentByAlKauser/${id}/${CNICNo}`).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", res.data.message, "", "i-chk-circle");
        })

        if (res.status === 200) {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("success", res.data.message, "", "i-chk-circle");
            setTimeout(() => {
                handleClose()
            }, 3000);
        }
    }

    const getApplicationById = async () => {
        const res = await httpClient.get(`/students/getApplicationById/${CNICNo}/${id}`).catch((error) => {
            snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
        })
        if (res?.status === 200) {
            setStudentData(res?.data)
        }
    }

    React.useEffect(() => {
        getApplicationById()
    }, [])


    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <React.Fragment>
            <CustomizedSnackbars ref={snackbar_Ref} />
            {
                studentData && (
                    <Dialog
                        open={props.open}
                        onClose={handleClose}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                    >
                        <DialogTitle id="scroll-dialog-title"><Typography variant='h5' sx={{ textAlign: "center", fontWeight: 'bold' }}>Student Info</Typography></DialogTitle>
                        <DialogContent dividers={scroll === 'paper'} >
                            <Stack justifyContent={'space-between'} sx={{ width: '100%', height: '100%' }}>
                                <Box
                                    sx={{
                                        alignSelf: 'flex-start',
                                        bgcolor:
                                            studentData.orphan === "yes"
                                                ? 'success.main'
                                                : studentData.orphan === "no"
                                                ? 'grey.600'
                                                : 'warning.main',
                                        color: '#fff',
                                        px: 2,
                                        py: 0.5,
                                        mb: 1,
                                        borderRadius: 1,
                                        fontWeight: 'bold',
                                        fontSize: 12,
                                    }}
                                >
                                    Orphan: {studentData.orphan === "yes" ? "Yes" : studentData.orphan === "no" ? "No" : "Not specified"}
                                </Box>
                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>First Name</Typography>
                                        <TextField
                                            value={studentData.firstName}
                                            onChange={(e) => { handleInputChange(e.target.value, "firstName", "text") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Last Name</Typography>
                                        <TextField
                                            value={studentData.lastName}
                                            onChange={(e) => { handleInputChange(e.target.value, "lastName", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Preferred Email</Typography>
                                        <TextField
                                            value={studentData.email}
                                            onChange={(e) => { handleInputChange(e.target.value, "email", "text") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Gender</Typography>
                                        <TextField
                                            value={studentData.gender}
                                            onChange={(e) => { handleInputChange(e.target.value, "gender", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Address</Typography>
                                        <TextField
                                            value={studentData.address}
                                            onChange={(e) => { handleInputChange(e.target.value, "address", "text") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Town</Typography>
                                        <TextField
                                            value={studentData.town}
                                            onChange={(e) => { handleInputChange(e.target.value, "town", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Phone Number (Mobile)</Typography>
                                        <TextField
                                            value={studentData.phoneNo_Mobile}
                                            onChange={(e) => { handleInputChange(e.target.value, "phoneNo_Mobile", "text") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Phone Number (Home)</Typography>
                                        <TextField
                                            value={studentData.phoneNo_Home}
                                            onChange={(e) => { handleInputChange(e.target.value, "phoneNo_Home", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                {/* <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>CNIC#</Typography>
                                        <TextField
                                            value={studentData.CNICNo}
                                            onChange={(e) => { handleInputChange(e.target.value, "CNICNo", "text") }}
                                        />

                                    </Stack>

                                
                                </Stack> */}



                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <Typography className='text-field-label'>Gross Household Income</Typography>
                                            <Tooltip title="Please enter the total income of all earning members of the household, including the parent(s).">
                                                <InfoOutlined sx={{ fontSize: 16, color: 'rgba(0, 0, 0, 0.54)', cursor: 'help' }} />
                                            </Tooltip>
                                        </Stack>
                                        <TextField
                                            value={studentData.presentHouseholdIncome}
                                            onChange={(e) => { handleInputChange(e.target.value, "presentHouseholdIncome", "number") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Total Family Members</Typography>
                                        <TextField
                                            value={studentData.totalFamilyMembers}
                                            onChange={(e) => { handleInputChange(e.target.value, "totalFamilyMembers", "number") }}
                                        />

                                    </Stack>
                                </Stack>


                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Father Name</Typography>
                                        <TextField
                                            value={studentData.fatherName}
                                            onChange={(e) => { handleInputChange(e.target.value, "fatherName", "text") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Mother Name</Typography>
                                        <TextField
                                            value={studentData.motherName}
                                            onChange={(e) => { handleInputChange(e.target.value, "motherName", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Course Title</Typography>
                                        <TextField
                                            value={studentData.courseTitle}
                                            onChange={(e) => { handleInputChange(e.target.value, "courseTitle", "text") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Grade/Class</Typography>
                                        <TextField
                                            value={studentData.grade}
                                            onChange={(e) => { handleInputChange(e.target.value, "grade", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Institution Name</Typography>
                                        <TextField
                                            value={studentData.institutionName}
                                            onChange={(e) => { handleInputChange(e.target.value, "institutionName", "text") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Institution Address</Typography>
                                        <TextField
                                            value={studentData.institutionAddress}
                                            onChange={(e) => { handleInputChange(e.target.value, "institutionAddress") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Tuition Fee</Typography>
                                        <TextField
                                            value={studentData.tuttionFee}
                                            onChange={(e) => { handleInputChange(e.target.value, "tuttionFee", "number") }}
                                        />

                                    </Stack>

                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Last Institution Attended</Typography>
                                        <TextField
                                            value={studentData.lastInstitutionAttended}
                                            onChange={(e) => { handleInputChange(e.target.value, "lastInstitutionAttended", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Class/Grade of Last Instition</Typography>
                                        <TextField
                                            value={studentData.classOfLastInstitution}
                                            onChange={(e) => { handleInputChange(e.target.value, "classOfLastInstitution", "text") }}
                                        />
                                    </Stack>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Amount</Typography>
                                        <TextField
                                            value={studentData.requestedAmount}
                                            onChange={(e) => { handleInputChange(e.target.value, "requestedAmount", "number") }}
                                        />
                                    </Stack>
                                </Stack>


                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Reference 1 Name</Typography>
                                        <TextField
                                            value={studentData.referenceName1}
                                            onChange={(e) => { handleInputChange(e.target.value, "referenceName1", "text") }}
                                        />

                                    </Stack>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Reference 1 Email</Typography>
                                        <TextField
                                            value={studentData.referenceEmail1}
                                            onChange={(e) => { handleInputChange(e.target.value, "referenceEmail1", "text") }}
                                        />

                                    </Stack>

                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Reference 1 Phone</Typography>
                                        <TextField
                                            value={studentData.referencePhone1}
                                            onChange={(e) => { handleInputChange(e.target.value, "referencePhone1") }}
                                        />
                                    </Stack>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Reference 2 Name</Typography>
                                        <TextField
                                            value={studentData.referenceName2}
                                            onChange={(e) => { handleInputChange(e.target.value, "referenceName2", "number") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>


                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Reference 2 Phone</Typography>
                                        <TextField
                                            value={studentData.referencePhone2}
                                            onChange={(e) => { handleInputChange(e.target.value, "referenceEmail2", "text") }}
                                        />

                                    </Stack>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>Reference 2 Email</Typography>
                                        <TextField
                                            value={studentData.referenceEmail2}
                                            onChange={(e) => { handleInputChange(e.target.value, "referenceEmail2", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                                <Stack flexDirection={'row'} className='text-field-container'>
                                    <Stack className='text-field'>
                                        <Typography className='text-field-label'>CNIC#</Typography>
                                        <TextField
                                            value={studentData.CNICNo}
                                            onChange={(e) => { handleInputChange(e.target.value, "CNICNo", "text") }}
                                        />

                                    </Stack>
                                </Stack>

                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'center'} sx={{ width: '100%' }}>
                                <Stack flexDirection={'row'} justifyContent={'space-between'} sx={{ width: role === 'admin' ? "39%" : role === 'al-kauser Admin' ? "39%" : '18%' }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: "#208146",
                                            color: 'white',
                                            width: '92px',
                                            height: "5vh",
                                            fontSize: '12px',
                                            borderRadius: '12px',
                                            "&:hover": {
                                                backgroundColor: "#208146",
                                            },
                                        }}
                                        onClick={role === 'admin' ? approvehandler : role === 'al-kauser Admin' ? approveByAlKauserHandler : handleClose}
                                    >
                                        {role === 'admin' ? "Approve" : role === 'al-kauser Admin' ? "Approve" : "Close"}
                                    </Button>
                                    {
                                        (role === 'admin' || role === 'al-kauser Admin') && <Button
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "white",
                                                color: 'black',
                                                width: '92px',
                                                height: "5vh",
                                                fontSize: '12px',
                                                borderRadius: '12px',
                                                "&:hover": {
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            onClick={role === 'al-kauser Admin' ? rejectByAlKauserHandler : rejectHandler}
                                        >
                                            Reject
                                        </Button>
                                    }

                                </Stack>

                            </Stack>
                        </DialogActions>
                    </Dialog>
                )
            }
        </React.Fragment>
    );
}